export const ALERT_TYPE = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning',
    BRAND: 'brand',
    DEFAULT: 'default',
};
